import type { SVGProps } from 'react'

export const ZaiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.5606 13.3584C19.7026 12.9378 20.2975 12.9378 20.4395 13.3584L20.4767 13.4685C21.3173 15.9574 23.2009 17.9566 25.6355 18.9438C26.011 19.096 26.011 19.6277 25.6355 19.78C23.2009 20.7672 21.3173 22.7662 20.4767 25.2553L20.4395 25.3654C20.2975 25.786 19.7026 25.786 19.5606 25.3654L19.5234 25.2553C18.6829 22.7662 16.7993 20.7672 14.3646 19.78C13.9891 19.6277 13.9891 19.096 14.3646 18.9438C16.7993 17.9566 18.6829 15.9574 19.5234 13.4685L19.5606 13.3584Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      d="M10.3406 8.90916C10.4529 8.60678 10.8806 8.60678 10.9929 8.90916C11.7002 10.8131 13.2067 12.3141 15.1125 13.0165C15.4164 13.1285 15.4164 13.5588 15.1125 13.6708C13.2067 14.3734 11.7002 15.8743 10.9929 17.7782C10.8806 18.0806 10.4529 18.0806 10.3406 17.7782C9.63331 15.8743 8.12679 14.3734 6.22105 13.6708C5.9172 13.5588 5.9172 13.1285 6.22105 13.0165C8.12679 12.3141 9.63331 10.8131 10.3406 8.90916Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      d="M17.1703 5.77233C17.2264 5.62114 17.4403 5.62114 17.4964 5.77233C17.85 6.7243 18.6034 7.47478 19.5562 7.82601C19.7082 7.88201 19.7082 8.09718 19.5562 8.15318C18.6034 8.50439 17.85 9.25487 17.4964 10.2069C17.4403 10.358 17.2264 10.358 17.1703 10.2069C16.8167 9.25487 16.0634 8.50439 15.1106 8.15318C14.9586 8.09718 14.9586 7.88201 15.1106 7.82601C16.0634 7.47478 16.8167 6.7243 17.1703 5.77233Z"
      fill="currentColor"
    />
  </svg>
)
